<template>
  <div>
    <a
      v-scroll-to="'#pageTop'"
      class="scroll-top" ref="scrollTop">
        <font-awesome-icon icon="angle-up" class="pointer"/>
    </a>
    <a
      v-scroll-to="'#pageBottom'"
      class="scroll-bottom " ref="scrollBottom">
        <font-awesome-icon icon="angle-down" class="pointer"/>
    </a>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        scrolled: 0,
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
     	handleScroll () {
        this.scrolled = window.scrollY;
        if (this.$refs.scrollTop) {
          if (this.scrolled > 100) {
            this.$refs.scrollTop.className ='scroll-top open';
            this.$refs.scrollBottom.className ='scroll-bottom open';
          } else {
            this.$refs.scrollTop.className ='scroll-top';
            this.$refs.scrollBottom.className ='scroll-bottom';
          }
        }
			}
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
  }
</script>


<style scoped>
  .scroll-top {
    background-color: rgb(88, 99, 128, 0.5) !important;
    height: 50px;
    width: 50px;
    position: fixed;
    top: 90%;
    right: 3%;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
    text-decoration: none;
    z-index: 999;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transition: 0.5s ease-out;
    transition: 0.5s ease-out;
    display: inline-block;
  }
  .scroll-top:hover {
    background-color: #7e007b;
  }
  .scroll-top.open {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  .scroll-top:hover,
  .scroll-top:focus {
    color: #fff;
  }


  .scroll-bottom  {
    background-color: rgb(88, 99, 128, 0.5) !important;
    height: 50px;
    width: 50px;
    position: fixed;
    top: 15%;
    right: 3%;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
    text-decoration: none;
    z-index: 999;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transition: 0.5s ease-out;
    transition: 0.5s ease-out;
    display: inline-block;
  }
  .scroll-bottom:hover {
    background-color: #7e007b;
  }
  .scroll-bottom.open {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  .scroll-bottom:hover,
  .scroll-bottom:focus {
    color: #fff;
  }
</style>
